import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { PDFViewerView } from "./pdfViewerView";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateStatusAuditDoc, updateStatusAuditDocClearData, } from "../../../store/generateQuote/actions";
import { showErrorToast } from "../../../fnx/showError";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import showToast from "../../../services/toast";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { StatusAuditDocument } from "../../../enum/statusAuditDocument";
import LocalStorageService from "../../../services/localStorage";
import { Steps } from "../../../enum/steps";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
export var PdfViewerApap = function () {
    var navigate = useNavigate();
    var idQuote = useParams().idQuote;
    var dispatch = useDispatch();
    var idDocument = useParams().idDocument;
    var t = useTranslation().t;
    var documentUrl = localStorageService.getStepStored().steps[Steps.auditDocumentUrl]
        .auditDocumentUrl;
    var _a = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _a[0], setSeeToast = _a[1];
    var _b = useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var _c = useSelector(function (state) { return ({
        responseUpdateStatusAuditDocs: state.Quote.responseUpdateStatusAuditDocs,
        errorUpdateStatusAuditDocs: state.Quote.errorUpdateStatusAuditDocs,
        loadingUpdateStatusAuditDocs: state.Quote.loadingUpdateStatusAuditDocs,
    }); }), responseUpdateStatusAuditDocs = _c.responseUpdateStatusAuditDocs, errorUpdateStatusAuditDocs = _c.errorUpdateStatusAuditDocs, loadingUpdateStatusAuditDocs = _c.loadingUpdateStatusAuditDocs;
    useEffect(function () {
        dispatch(updateStatusAuditDocClearData());
    }, []);
    useEffect(function () {
        if (errorUpdateStatusAuditDocs) {
            showErrorToast(errorUpdateStatusAuditDocs, setSeeToast, t);
        }
    }, [errorUpdateStatusAuditDocs]);
    useEffect(function () {
        if (responseUpdateStatusAuditDocs) {
            showToastSuccessMessage(t("pdfViewer.approveAuditDocument"), typeAlert.success, setSeeToast);
            onBack();
            dispatch(updateStatusAuditDocClearData());
        }
    }, [responseUpdateStatusAuditDocs]);
    var onBack = function () {
        navigate("/fiscalizacion-apap-auto/".concat(idQuote));
    };
    var updateStatusAuditDocument = function (status, comment) {
        var body = {
            comment: comment,
        };
        dispatch(updateStatusAuditDoc({
            quoteId: idQuote,
            documentId: idDocument,
            status: status,
            body: body,
        }));
    };
    var onRejected = function () {
        setOpenDrawer(true);
    };
    var onCloseDrawer = function () {
        setOpenDrawer(false);
    };
    var applyValue = function (data) {
        updateStatusAuditDocument(StatusAuditDocument.REJECTED, data.descriptionValue.value);
        setOpenDrawer(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingUpdateStatusAuditDocs, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando..." }), _jsx(PDFViewerView, { onBack: onBack, approveDocument: updateStatusAuditDocument, onRejectedDocument: onRejected, url: documentUrl, t: t, loading: loadingUpdateStatusAuditDocs, titleDrawer: "Rechazar documento", txtLegendDrawer: "Razón del rechazo: Es obligatorio proporcionar una explicación clara del motivo del rechazo del documento.", titleButtonDrawer: "Rechazar", placeHolderDrawer: "Escriba una descripcion para sustentar el rechazo del documento", subTitleDrawer: "Formulario conocimiento persona fisica", openDrawer: openDrawer, onValueApply: applyValue, onCloseDrawer: onCloseDrawer })] }));
};
